import React from 'react';
import { Box, IconButton, Paper } from '@mui/material';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';

const CycleSidePanel = ({ isOpen, onToggle, children }) => {
  return (
    <>
      {/* Side Panel */}
      <Box
        sx={{
          position: 'fixed',
          top: 64, // Below app bar
          right: 0,
          bottom: 0,
          width: isOpen ? '450px' : '0px',
          transition: 'width 0.3s ease-in-out',
          zIndex: 1200,
          overflow: 'hidden',
        }}
      >
        <Paper
          elevation={8}
          sx={{
            height: '100%',
            width: '450px',
            display: 'flex',
            flexDirection: 'column',
            borderRadius: 0,
            borderLeft: '1px solid rgba(0, 0, 0, 0.12)',
            overflow: 'hidden',
          }}
        >
          {/* Panel Content */}
          <Box
            sx={{
              flex: 1,
              overflowY: 'auto',
              p: 2,
            }}
          >
            {children}
          </Box>
        </Paper>
      </Box>

      {/* Lash/Tab Button */}
      <Box
        sx={{
          position: 'fixed',
          top: '50%',
          right: isOpen ? '450px' : '0px',
          transform: 'translateY(-50%)',
          transition: 'right 0.3s ease-in-out',
          zIndex: 1201,
        }}
      >
        <Paper
          elevation={4}
          sx={{
            borderTopLeftRadius: 8,
            borderBottomLeftRadius: 8,
            borderTopRightRadius: 0,
            borderBottomRightRadius: 0,
            overflow: 'hidden',
          }}
        >
          <IconButton
            onClick={onToggle}
            sx={{
              borderRadius: 0,
              width: 32,
              height: 64,
              '&:hover': {
                backgroundColor: 'primary.light',
                color: 'white',
              },
            }}
          >
            {isOpen ? <ChevronRightIcon /> : <ChevronLeftIcon />}
          </IconButton>
        </Paper>
      </Box>
    </>
  );
};

export default CycleSidePanel;
